import { render, staticRenderFns } from "./RegionUnitDistribution.vue?vue&type=template&id=b4375066&scoped=true&"
import script from "./RegionUnitDistribution.vue?vue&type=script&lang=js&"
export * from "./RegionUnitDistribution.vue?vue&type=script&lang=js&"
import style0 from "./RegionUnitDistribution.vue?vue&type=style&index=0&id=b4375066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4375066",
  null
  
)

export default component.exports